export default __webpack_public_path__ + "static/media/industrial.73fe2647.png";